import { C } from "../data/content";
import { Accordion } from "./Curriculum";

export const FAQSection = () => (
  <section id="faq" className="py-28 px-6 lg:px-12" data-testid="faq-section">
    <div className="max-w-[900px] mx-auto">
      <p className="mono text-[11px] tracking-[0.25em] text-[var(--accent)] mb-6">[008] — GOOD TO KNOW</p>
      <h2 className="h1-display text-[clamp(28px,3.4vw,48px)] mb-12">COMMON QUESTIONS</h2>
      <Accordion items={C.faq.map((f) => ({ title: f.q, body: f.a }))} testPrefix="faq" defaultOpen={-1} />
    </div>
  </section>
);
